import { Link } from "react-router-dom";
import { ArrowRight, Star } from "lucide-react";
import { REVIEWS } from "@/data/content";
import { Reveal, Eyebrow } from "./Reveal";
import { FounderPhoto } from "./FounderPhoto";

export const StoryTeaser = () => (
  <section data-testid="home-story-teaser" className="py-20 lg:py-28 bg-[#BDE3FA]">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8 grid lg:grid-cols-12 gap-10 items-center">
      <Reveal className="lg:col-span-5"><FounderPhoto /></Reveal>
      <Reveal delay={0.1} className="lg:col-span-6 lg:col-start-7">
        <Eyebrow className="text-[#1B1530]/70 mb-4">The kid behind the bag</Eyebrow>
        <h2 className="font-display text-4xl sm:text-6xl leading-[0.95]">Started at 14 with $300 and a serious sweet tooth.</h2>
        <p className="mt-6 text-base sm:text-lg text-[#1B1530]/80 leading-relaxed max-w-xl">Rory couldn't find a snack that tasted like real candy and was actually better for him. 800+ test batches later, Swole Bears is in 119 stores (with 200 more in the works) and made in our own 5,000+ sq ft Nova Scotia production facility.</p>
        <div className="mt-8 grid grid-cols-3 gap-3 max-w-md">
          {[["$300", "to start"], ["800+", "test batches"], ["119", "stores"]].map(([a, b]) => (
            <div key={a} className="rounded-2xl bg-white/70 p-4"><p className="font-display text-3xl sm:text-4xl">{a}</p><p className="text-xs font-semibold mt-1">{b}</p></div>
          ))}
        </div>
        <Link to="/story" data-testid="home-read-story-link" className="mt-8 inline-flex items-center gap-2 h-12 px-6 rounded-full bg-[#1B1530] text-white font-bold hover:bg-[#FF5A5F] transition-colors">Read Rory's story <ArrowRight className="h-4 w-4" /></Link>
      </Reveal>
    </div>
  </section>
);

export const ReviewsTeaser = () => (
  <section data-testid="home-reviews-teaser" className="py-20 lg:py-28">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
      <Reveal className="flex flex-wrap items-end justify-between gap-4 mb-10">
        <div>
          <Eyebrow className="text-[#FF5A5F] mb-4">5.0 stars on swolebears.ca</Eyebrow>
          <h2 className="font-display text-4xl sm:text-6xl leading-[0.95]">"You can't even tell it's protein."</h2>
        </div>
        <Link to="/reviews" data-testid="home-all-reviews-link" className="inline-flex items-center gap-2 h-12 px-6 rounded-full border-2 border-[#1B1530] font-bold hover:bg-[#1B1530] hover:text-white transition-colors">Reviews &amp; reactions <ArrowRight className="h-4 w-4" /></Link>
      </Reveal>
      <div className="grid md:grid-cols-3 gap-4">
        {REVIEWS.slice(1, 4).map((r, i) => (
          <Reveal key={r.name} delay={i * 0.08} className="rounded-[28px] bg-white border border-[#1B1530]/10 p-7">
            <div className="flex gap-0.5 text-[#FFB21A]">{[0, 1, 2, 3, 4].map((s) => <Star key={s} className="h-4 w-4 fill-current" />)}</div>
            <p className="mt-4 text-[17px] leading-relaxed">"{r.text}"</p>
            <p className="mt-5 text-sm font-bold text-[#4A4560]">{r.name}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
